import React, { useEffect, useState } from 'react';
import { Field } from './Field';
import { Grid, Stack, Center, Loader, Skeleton, Alert } from '@mantine/core';
import { getScreen } from '../../../helpers/screen/backend_helper';
import { ScreenSkeleton } from './ScreenSkeleton';
import { useForm } from '@mantine/form';
import { Button } from 'reactstrap';
import CardWithError from '../../../Components/Common/CardWithError';

export const Screen = ({ screenId }) => {
	const [screen, setScreen] = useState();
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const form = useForm();

	useEffect(() => {
		if (screenId) {
			setIsLoading(true);
			setError(null);

			getScreen(screenId)
				.then(response => setScreen(response))
				.catch(error => setError(error))
				.finally(() => {
					setIsLoading(false);
					form.reset();
				});
		}
	}, [screenId]);

	if (isLoading) {
		return <ScreenSkeleton />;
	}

	if (error) {
		return <CardWithError />;
	}

	return (
		<div>
			<h1>{screen && screen?.name}</h1>
			<h3>{screen && screen?.description}</h3>
			<form
				onSubmit={form.onSubmit(values => {
					console.log(values);
				})}
			>
				<Stack>
					{screen &&
						screen?.fields.map((row, index) => (
							<Grid key={index}>
								{row.map((field, index) => (
									<Field key={index} form={form} field={field} />
								))}
							</Grid>
						))}
					<Button disabled={!form.isDirty()} type='submit'>
						Enviar
					</Button>
				</Stack>
			</form>
		</div>
	);
};
